import AsyncStorage from '@react-native-async-storage/async-storage'

import { logger } from '../logging/logger'

// Per Fun user, so two accounts don't inherit each other's chain. Hosts that
// omit `externalUserId` get the wallet address as the userId, so for them a
// wallet change already scopes to a new key.
const storageKey = (userId: string) => `funkit.selectedChain.${userId}`

/** Null when nothing is stored, or the read failed — the caller just asks. */
export async function readSelectedChainId(
  userId: string,
): Promise<string | null> {
  try {
    return await AsyncStorage.getItem(storageKey(userId))
  } catch (error) {
    logger.warn('connect-rn:deposit:chain_read_failed', {
      error: error instanceof Error ? error.message : String(error),
    })
    return null
  }
}

export async function writeSelectedChainId(
  userId: string,
  chainId: string,
): Promise<void> {
  try {
    await AsyncStorage.setItem(storageKey(userId), chainId)
  } catch (error) {
    logger.warn('connect-rn:deposit:chain_write_failed', {
      chainId,
      error: error instanceof Error ? error.message : String(error),
    })
  }
}
